// extracted by mini-css-extract-plugin
export default {"form":"form_form__6MLiU","modal":"form_modal__NWcx5","noGap":"form_noGap__xO36T"};